import { Box, Typography } from "@mui/material";
import DashboardMapDynamic from "./DashboardMapDynamic";
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import api from '../../../redux/features/auth/axiosAuthHelper';
import type { FeatureCollection } from 'geojson';

const MapContainer = () => {
    const authData = useSelector((state: RootState) => state.auth);
    const [mapData, setMapData] = useState<FeatureCollection>(
        {
            type: "FeatureCollection",
            features: [
            ],
        }
    );
    const [errors, setErrors] = useState<string | null>(null);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const url = `results/geo-locations`;

                const response = await api.get(url, {
                    headers: {
                        'Authorization': `Bearer ${authData.access}`
                    }
                });
                setMapData(response.data);
                console.log('Map Data', response.data);

            } catch (error) {
                console.error('Error fetching user', error);
                setErrors(`No Data`)
            }
        };
        fetchData();
    }, []);

    return (
        <Box sx={{ width: '100%', height: '530px' }}>
            {/* <Typography sx={{ minHeight: '30px', maxHeight: '30px' }}>Buttons</Typography> */}
            <DashboardMapDynamic mapData={mapData} />
        </Box>
    );
}

export default MapContainer;